<div *ngIf='screenWidth > 1230'>
  <nav class="navbar bmw-nav"
    style="margin-bottom: 0px !important;" [style]="setBackgroundStyle">
    <ul class="nav navbar-nav navbar-left">

      <li>
        <a [routerLink]="['/home']">
          <span class="bmw-navbar-content-box" [style]="setFontStyle">Home </span>
        </a>
      </li>
      <li class="dropdown">
        <a href="#" data-toggle="dropdown" class="dropdown-toggle">
          <span class="bmw-navbar-content-box" [style]="setFontStyle">Service Information </span>
          <b class="caret" [style]="setFontStyle"></b>
        </a>
        <ul class="dropdown-menu bmw-dropdown-background">
          <li>
            <a [routerLink]='["/sib-home"]'>
              <span class="bmw-dropdown-content">Service Bulletins</span>
            </a>
          </li>
          <li>
            <a [routerLink]='["/obd"]'>
              <span class="bmw-dropdown-content">OBD</span>
            </a>
          </li>
          <li *ngIf="APP_SETTINGS.isRollsRoyce == 'false' && APP_SETTINGS.isMOTORRAD == 'false'">
            <a [routerLink]='["/legacy"]'>
              <span class="bmw-dropdown-content">Legacy</span>
            </a>
          </li>
        </ul>
      </li>
      <li *ngIf="isExternal == 'false'">
        <a routerLink="/parts-home">
          <span class="bmw-navbar-content-box" [style]="setFontStyle">Parts Bulletins</span>
        </a>
      </li>

      <li class="dropdown">
        <a href="#" data-toggle="dropdown" class="dropdown-toggle">
          <span class="bmw-navbar-content-box" [style]="setFontStyle"> Training </span>
          <b class="caret" [style]="setFontStyle"></b>
        </a>
        <ul class="dropdown-menu bmw-dropdown-background">
          <li>
            <a routerLink="/tech-training-manual">
              <span class="bmw-dropdown-content">Technical Training Manuals</span>
            </a>
          </li>
          <li>
            <a routerLink="/body-paint-manual">
              <span class="bmw-dropdown-content">Body & Paint Manuals</span>
            </a>
          </li>
        </ul>
      </li>

      <li class="dropdown" *ngIf="APP_SETTINGS.isMOTORRAD == 'false'">
        <a href="#" data-toggle="dropdown" class="dropdown-toggle">
          <span class="bmw-navbar-content-box" [style]="setFontStyle"> Tools & Equipment </span>
          <b class="caret" [style]="setFontStyle"></b>
        </a>
        <ul class="dropdown-menu bmw-dropdown-background">
          <li>
            <a routerLink="/equip-manual">
              <span class="bmw-dropdown-content">Equipment Manuals</span>
            </a>
          </li>
          <li>
            <a routerLink="/tool-report">
              <span class="bmw-dropdown-content">Tool Report</span>
            </a>
          </li>
          <li>
            <a [routerLink]='["/faq"]'>
              <span class="bmw-dropdown-content">FAQ & Top Links</span>
            </a>
          </li>
        </ul>
      </li>
      <li>
        <a *ngIf="APP_SETTINGS.isMOTORRAD == 'true'" routerLink="/equip-manual">
          <span class="bmw-navbar-content-box" [style]="setFontStyle">Equipment Manuals </span>
        </a>
      </li>

      <li>
        <a routerLink="/videos">
          <span class="bmw-navbar-content-box" [style]="setFontStyle">Videos </span>
        </a>
      </li>
      <li>
        <a *ngIf="APP_SETTINGS.isMOTORRAD == 'false'" routerLink="/noise-catalog">
          <span class="bmw-navbar-content-box" [style]="setFontStyle">Noise Catalog </span>
        </a>
      </li>
      <li *ngIf="APP_SETTINGS.isBMW == 'true' || APP_SETTINGS.isMINI == 'true'">
        <a routerLink="/scope-pattern">
          <span class="bmw-navbar-content-box" [style]="setFontStyle">Scope Pattern </span>
        </a>
      </li>
      <li *ngIf='isCar'>
        <a [routerLink]='["/takata-recall"]'>
          <span class="bmw-navbar-content-box" [style]="setFontStyle">Takata Recall </span>
        </a>
      </li>

      <li *ngIf="isExternal == 'true'" class="dropdown">

        <a href="#" data-toggle="dropdown" class="dropdown-toggle">
          <span class="bmw-navbar-content-box" [style]="setFontStyle">AOS </span>
          <b class="caret" [style]="setFontStyle"></b>
        </a>
        <ul class="dropdown-menu bmw-dropdown-background">
          <li *ngFor="let item of ossLinks; let i = index">
            <a [routerLink]='["/oss"]' [queryParams]='{ossLinkName : item.linkName, ossLink: item.linkURL}'>
              <span class="bmw-dropdown-content">{{item.linkName}}</span>
            </a>
          </li>
        </ul>
      </li>

      <li *ngIf="isExternal == 'false'">
        <a [routerLink]='["/tech-doc"]'>
          <span class="bmw-navbar-content-box" [style]="setFontStyle">Technical Documentation </span>
        </a>
      </li>
    </ul>
  </nav>
</div>
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <div *ngIf='!(hideNavbar)' class="bmw-navbar-md-rectangle" [style]="setBackgroundStyle">
    <nav class="navbar bmw-nav" style="margin-bottom: 0px !important;">
      <ul class="nav navbar-nav navbar-left">

        <li>
          <a routerLink="/home">
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Home </span>
          </a>
        </li>
        <li class="dropdown">
          <a href="#" data-toggle="dropdown" class="dropdown-toggle">
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Service Information </span>
            <b class="caret" [style]="setFontStyle"></b>
          </a>
          <ul class="dropdown-menu bmw-dropdown-background">
            <li>
              <a [routerLink]='["/sib-home"]'>
                <span class="bmw-dropdown-content bmw-font-size-12">Service Bulletins</span>
              </a>
            </li>
            <li>
              <a [routerLink]='["/obd"]'>
                <span class="bmw-dropdown-content bmw-font-size-12">OBD</span>
              </a>
            </li>
            <li *ngIf="APP_SETTINGS.isRollsRoyce == 'false' && APP_SETTINGS.isMOTORRAD == 'false'">
              <a [routerLink]='["/legacy"]'>
                <span class="bmw-dropdown-content bmw-font-size-12">Legacy</span>
              </a>
            </li>
          </ul>
        </li>
        <li *ngIf="isExternal == 'false'">
          <a routerLink="/parts-home">
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Parts Bulletins</span>
          </a>
        </li>

        <li class="dropdown">
          <a href="#" data-toggle="dropdown" class="dropdown-toggle">
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle"> Training </span>
            <b class="caret" [style]="setFontStyle"></b>
          </a>
          <ul class="dropdown-menu bmw-dropdown-background">
            <li>
              <a [routerLink]='["/tech-training-manual"]'>
                <span class="bmw-dropdown-content bmw-font-size-12">Technical Training Manuals</span>
              </a>
            </li>
            <li>
              <a *ngIf="APP_SETTINGS.isMOTORRAD == 'false'" [routerLink]='["/body-paint-manual"]'>
                <span class="bmw-dropdown-content bmw-font-size-12">Body & Paint Manuals</span>
              </a>
            </li>
          </ul>
        </li>

        <li class="dropdown" *ngIf="APP_SETTINGS.isMOTORRAD == 'false'">
          <a href="#" data-toggle="dropdown" class="dropdown-toggle">
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle"> Tools & Equipment </span>
            <b class="caret" [style]="setFontStyle"></b>
          </a>
          <ul class="dropdown-menu bmw-dropdown-background">
            <li>
              <a [routerLink]='["/equip-manual"]'>
                <span class="bmw-dropdown-content bmw-font-size-12">Equipment Manuals</span>
              </a>
            </li>
            <li>
              <a [routerLink]='["/tool-report"]'>
                <span class="bmw-dropdown-content bmw-font-size-12">Tool Report</span>
              </a>
            </li>
            <li>
              <a [routerLink]='["/faq"]'>
                <span class="bmw-dropdown-content bmw-font-size-12">FAQ & Top Links</span>
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a *ngIf="APP_SETTINGS.isMOTORRAD == 'true'" routerLink="/equip-manual">
            <span class="bmw-navbar-content-box" [style]="setFontStyle">Equipment Manuals </span>
          </a>
        </li>

        <li>
          <a routerLink="/videos">
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Videos </span>
          </a>
        </li>
        <li>
          <a *ngIf="APP_SETTINGS.isMOTORRAD == 'false'" routerLink="/noise-catalog">
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Noise Catalog </span>
          </a>
        </li>
        <li *ngIf="APP_SETTINGS.isBMW == 'true' || APP_SETTINGS.isMINI == 'true'">
          <a routerLink="/scope-pattern">
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Scope Pattern </span>
          </a>
        </li>
        <li *ngIf='isCar'>
          <a [routerLink]='["/takata-recall"]'>
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Takata Recall </span>
          </a>
        </li>

        <li *ngIf="isExternal == 'true'" class="dropdown">

          <a href="#" data-toggle="dropdown" class="dropdown-toggle">
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">AOS </span>
            <b class="caret" [style]="setFontStyle"></b>
          </a>
          <ul class="dropdown-menu bmw-dropdown-background">
            <li *ngFor="let item of ossLinks; let i = index">
              <a [routerLink]='["/oss"]' [queryParams]='{ossLinkName : item.linkName, ossLink: item.linkURL}'>
                <span class="bmw-dropdown-content bmw-font-size-12">{{item.linkName}}</span>
              </a>
            </li>
          </ul>
        </li>
        <li *ngIf="isExternal == 'false'">
          <a [routerLink]='["/tech-doc"]'>
            <span class="bmw-navbar-md-rectangle-content" [style]="setFontStyle">Technical Documentation </span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>